import NotSoSimpleMarkdown from 'simple-markdown'

// Setup NotSoSimpleMarkdown
// Here's a whitelistof things we accept in our markdown string
const markdownRules = {
  br: {
    ...NotSoSimpleMarkdown.defaultRules.br,
    match: NotSoSimpleMarkdown.anyScopeRegex(/^\n\n/),
    parse: function () {
      return {}
    },
    react: function (node: any, output: any, state: any) {
      return NotSoSimpleMarkdown.reactElement('br', state.key, {})
    }
  },
  list: NotSoSimpleMarkdown.defaultRules.list,
  link: {
    ...NotSoSimpleMarkdown.defaultRules.link,
    react: function (node: any, output: any, state: any) {
      return (
        <a
          key={state.key}
          href={NotSoSimpleMarkdown.sanitizeUrl(node.target)}
          target="_blank"
          rel="noopener noreferrer"
          title={node.title}
        >
          {output(node.content, state)}
        </a>
      )
    }
  },
  em: NotSoSimpleMarkdown.defaultRules.em,
  escape: NotSoSimpleMarkdown.defaultRules.escape,
  strong: NotSoSimpleMarkdown.defaultRules.strong,
  text: NotSoSimpleMarkdown.defaultRules.text,
  strongUnderline: {
    ...NotSoSimpleMarkdown.defaultRules.strong,
    match: NotSoSimpleMarkdown.inlineRegex(/^__([\S\s]+?)__(?!_)/)
  },
  // We no longer allow images inline with text (use the image component)
  // image: NotSoSimpleMarkdown.defaultRules.image,
  icon: {
    order: NotSoSimpleMarkdown.defaultRules.em.order - 0.5,
    match: NotSoSimpleMarkdown.inlineRegex(/^{{2}icon\((\w+)(?:,\s*(#?\w+))?(?:,\s*(#?\w+))?\)}{2}/i),
    parse: function (capture: any, parse: any, state: any) {
      // TODO Some logic around if the state color exists (state.color comes from a textblock CSS)
      const stateColor = state.style && state.style.color
      return {
        iconName: capture[1],
        fillColor: stateColor || capture[2],
        strokeColor: stateColor || capture[3]
      }
    },
    react: function (node: any, output: any, state: any) {
      // The styles for an "icon" are set here
      const iconStyles = {
        height: '1em',
        width: '1em',
        fill: node.fillColor,
        stroke: node.strokeColor,
        marginRight: 2
      }
      return (
        <svg key={state.key} style={iconStyles}>
          <use xlinkHref={`#inline-icon-${node.iconName}`} />
        </svg>
      )
    }
  }
}

// Create the parser with these rules
const rawBuiltParser = NotSoSimpleMarkdown.parserFor(markdownRules)
const parse = (source: any) => {
  return rawBuiltParser(source, { inline: true })
}
const reactOutput = NotSoSimpleMarkdown.reactFor(NotSoSimpleMarkdown.ruleOutput(markdownRules, 'react'))

export default function processMarkdown(text: any) {
  // Shortcut for empty text
  if (!text) {
    return null
  }
  const parseTree = parse(text)
  return reactOutput(parseTree)
}
